const initValue = {
  finished: false,
  deliveryMethods: [],
  variants: {},
  bankAccounts: [],
  allowed_region: {
    id: '',
    name: '',
    code: '',
    provinces: [],
  },
  orderAmount: {
    original_amount: null,
    fee_amount: null,
    fees: {},
    summary_total_amount: null,
    exchange_items_amount: null,
    store_credit_extra_amount: null,
    currency: 'EUR',
    amount: null,
    remaining_amount: null,
    remaining_amount_in_store_currency: null,
    reveni_coverage_amount: null,
    bonus_amount: null,
    bonuses: {},
  },
  merchantInfo: {
    id: '',
    name: '',
    slug: '',
    contact_email: '',
    disable_return_label_delay: false,
    domain: '',
    currency: '',
    merchant: {
      id: '',
      country: { code: '', name: '', phone_code: '', region_id: '' },
      stores: [],
    },
    country: {
      code: '',
      name: '',
      phone_code: '',
      region_id: '',
    },
    preferences: {
      transaction_types: [],
      delivery_methods: [],
      max_duration_for_return: '',
      reject_url: '',
      return_expiration_delta: '',
      shipping_included: false,
      success_url: '',
      returns_policy_url: null,
      allows_unified_flow: false,
      allows_instant_exchanges: false,
      disable_preselected_refund_methods: false,
      disable_preselected_delivery_methods: false,
      allows_multi_order_returns: false,
      promote_exchanges: false,
    },
  },
  orderInfo: {
    is_instant_exchange_allowed: false,
    email: '',
    id: '',
    type: '',
    currency: '',
    returnId: '',
    orderNumber: '',
    original_shipping_address: {},
    shipping_address: {},
    transaction_type: '',
    reject_url: '',
    success_url: '',
    allowed_refund_methods: [],
    issue_refund_at_status: '',
    exchanged_for_order: {
      amount: '',
      currency: '',
      checkout_url: '',
      needs_payment: false,
    },
    customer_profile: {
      first_name: '',
      last_name: '',
      email: {
        id: '',
        email: '',
        primary: '',
        verified: '',
      },
    },
    carbon_offset: false,
    carbonOffset: false,
    customer_iban: null,
    numberOfReturnLabels: 1,
    selectedPickupDate: null,
    selectedTimeRange: null,
    customers_url: '',
    available_transaction_types: [],
    available_transaction_types_for_region: [],
    sendCustomerNotification: true,
    refund_amounts: {},
  },
  items: [],
  draftItems: [],
  summary: {
    productsToReturn: {
      total: null,
      products: [],
    },
    newRequestedProducts: {
      total: null,
      products: [],
    },
    fees: {
      total: null,
      fees: {},
    },
    bonuses: {
      total: null,
      bonuses: {},
    },
    remaining_amount: null,
    summary_total_amount: null,
    currency: 'EUR',
  },
  summaryCollapsed: false,
}

export default initValue
